import { LoadingFull } from 'components/Loading';
import aptActions from 'features/booking/services/actions';
import { couponActions } from 'features/coupon/services/reducers';
import NotFoundPage from 'features/NotFound';
import billActions from 'features/receipt/services/actions';
import { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import shopActions from 'services/shop/actions';
import { SHOP_ID_BLACKLIST } from 'services/shop/constants';
import shopSelectors from 'services/shop/selectors';
import { useAppDispatch } from 'store/hooks';

const PrivateLayout = () => {
  const { shop_id = '', bill_id = '', trans_id = '' } = useParams();
  const dispatch = useAppDispatch();
  const loadingShop = shopSelectors.getShopInfoLoading();

  useEffect(() => {
    if (shop_id) {
      dispatch(shopActions.getShopInfo.fetch(shop_id));
    }

    if (bill_id && location.pathname.endsWith('/receipt')) {
      dispatch(billActions.fetchReceiptData({ billId: bill_id, shopId: shop_id }));
    }

    if (location.pathname.endsWith('coupon-receive')) {
      dispatch(couponActions.getCouponReceiveDiscountSetting.fetch(shop_id));
      dispatch(couponActions.getReferralDiscountExitsCustomer.fetch(shop_id));
    }
    if (location.pathname.endsWith('coupon-receive-v2')) {
      dispatch(couponActions.getCouponReceiveDiscountSetting.fetch(shop_id));
      dispatch(couponActions.getBirthdayDiscount.fetch(shop_id));
      dispatch(couponActions.getReferralDiscountExitsCustomer.fetch(shop_id));
    }
    if (location.pathname.endsWith('coupon-referral')) {
      dispatch(couponActions.getCouponReceiveDiscountSetting.fetch(shop_id));
      dispatch(couponActions.getReferralDiscountExitsCustomer.fetch(shop_id));
    }
    if (location.pathname.includes('booking-v2')) {
      dispatch(shopActions.get.categories.fetch(shop_id));
      dispatch(shopActions.get.allShopSetting.fetch(shop_id));
      dispatch(shopActions.get.notification.fetch(shop_id));
      dispatch(shopActions.get.settingDepositBooking.fetch(shop_id));
    }
    if (location.pathname.includes('booking-v3')) {
      dispatch(shopActions.get.categories.fetch(shop_id));
      dispatch(shopActions.get.allShopSetting.fetch(shop_id));
      dispatch(shopActions.get.notification.fetch(shop_id));
      dispatch(shopActions.get.settingDepositBooking.fetch(shop_id));
    }
    if (location.pathname.includes('deposit-transaction')) {
      dispatch(aptActions.getDepositTransactionData.fetch(trans_id));
    }
    if (location.pathname.includes('services-menu')) {
      dispatch(shopActions.get.servicesByCategory.fetch(shop_id));
    }
  }, []);

  if (loadingShop) return <LoadingFull />;

  if (SHOP_ID_BLACKLIST.includes(shop_id)) return <NotFoundPage />;

  return (
    <div><Outlet /></div>
  );
};

export default PrivateLayout;
